export class TokenJWT {
  /** Token in formato stringa. */
  private _tokenString: string;
  /** Dati di creazione del Token. */
  private _header!: any;
  /** Corpo del Token. */
  private _payload!: any;
  /** Firma del Token. */
  private _sign!: string;

  constructor(tokenString: string) {
    this._tokenString = tokenString;
    this.init();
  }

  get header(): any {
    return this._header;
  }

  get payload(): any {
    return this._payload;
  }

  set token(tokenString: string) {
    this._tokenString = tokenString;
    this.init();
  }

  public isValid(): boolean {
    if (!this._payload || !this._payload.exp) {
      return false;
    }
    const expirationDate = new Date(this._payload.exp * 1000);
    return expirationDate > new Date();
  }

  public toString() {
    return this._tokenString;
  }

  private init() {
    const parts = this._tokenString.split('.');
    if (parts.length == 3) {
      this._header = this.decodeB64(parts[0]);
      this._payload = this.decodeB64(parts[1]);
      this._sign = parts[2];
    } else {
      throw new Error('Stringa non TokenJWT');
    }
  }

  private decodeB64(stringB64: string): any {
    return JSON.parse(atob(stringB64));
  }
}
